import {Component} from '@angular/core';
import {combineLatest, Observable} from "rxjs";
import {Wod} from "../../model/wod";
import {TimeslotAttribute} from "../../model/timeslot_attribute";
import {Store} from "@ngxs/store";
import {AppointmentState} from "../../state/appointment.state";
import {map} from "rxjs/internal/operators";

@Component({
  selector: 'appointment-detail-attributes',
  templateUrl: './detail-attributes.component.html',
  styleUrls: ['./detail-attributes.component.scss']
})
export class DetailAttributesComponent {
  public timeslot$: Observable<Wod>;
  personaId$: Observable<string | undefined>;
  attributes$: Observable<TimeslotAttribute[]>;
  subscribed = false;

  constructor(private store: Store) {
    this.timeslot$ = this.store.select(AppointmentState.currentAppointment);
    this.personaId$ = this.store.select(AppointmentState.persona);

    this.attributes$ = combineLatest([this.timeslot$, this.personaId$]).pipe(
      map(([timeslot, personaId]) => {
        this.subscribed = timeslot.isSubscribed(personaId);
        return timeslot.attributes(personaId);
      })
    )
  }
}
